export const FIELD_ID = 'courseId';
export const DISCLAIMER_TEXT =
  'The availability of features and functionality shown in this learning path depends on your product subscription. To learn more about Atlassian product subscriptions, ';
export const CUSTOM_MOBILE_WIDTH = 920;
export const CUSTOM_TABLET_WIDTH = 1200;
